import { useEffect, useRef } from "react"

export const usePreviousValue = <T>(prev: T) => {
  const ref = useRef(prev)

  useEffect(() => {
    ref.current = prev
  }, [prev])
  
  return ref.current
}
